module.exports = __webpack_public_path__ + "static/img/1_5_2.b1880b09.jpg";